module.exports = __webpack_public_path__ + "static/media/Lucky Me.3e3bfd32.jpg";